









import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import ButtonInspectResult from "@/components/common/button/ButtonInspectResult.vue";

@Component({
  components: {
    appButtonInspectResult: ButtonInspectResult
  }
})
export default class TopBarTitle extends Vue {
  @Prop() titleText: string;
  @Prop() isEdit: boolean;
  @Prop() addClass: any;
  @Prop({ default: false }) disabled: boolean;

  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  isExitNexListSet: boolean = false; // 初期化関数制御

  editBtn: boolean = false;
  listTab: string[] = [];
  routeName: any = "";

  @Watch("$route")
  onRouteChange(to: any, from: any) {
    // ルート名保持
    this.routeName = to.name;
    this.checkButtonStatusResult(); // リスト更新
  }

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("isNextageCustom")
  nexListSet() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.isNextageCustom || this.isExitNexListSet) {
      return;
    }
    this.isExitNexListSet = true;

    // ネク用に編集可能な画面をリセットして全不許可にする
    this.listTab = [];
    this.checkButtonStatusResult(); // リスト更新
  }

  created() {
    // ルート名保持
    this.routeName = this.$route.name;

    if( this.isNextageCustom ) {
      this.nexListSet();
    } else {
      // 編集可能な画面をセットする
      // 法定57点検項目 / おすすめ整備 / 車検費用 / クーポン / クイック見積 / 見積り明細
      this.listTab = [ 
        "userlegal56",
        "userrecommend",
        "inspectioncost",
        "discountcoupon",
        "quickmitsumori",
        "option",
        "estimate"
      ];
      this.checkButtonStatusResult(); // リスト更新
    }
  }

  checkButtonStatusResult() {
    // console.log("TopBarTitle.checkButtonStatusResult route => ", route);
    if ( this.listTab.filter(data => data == this.routeName).length != 0
    ) {
      this.editBtn = true;
    } else {
      this.editBtn = false;
    }
  }

  onEdit() {
    const isEdit = !this.isEdit;
    this.$emit("onEditPrice", isEdit);
  }
}
